import React from "react";

function SignzData() {
  return (
    <div id="signzdata">
      <div className="signzinfo">
        <div className="signzline">
          A Tool to Measure, Guide, and Resonate the present Socio-Economic Operating Systems
          <div className="signzbutton">
            <span>
              <a
                className="anchor-no-decoration"
                href="https://www.signzclub.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                Know More About Our
              </a>
            </span>
            <span>
              <a
                className="anchor-flag"
                href="https://www.signzclub.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                Flagship Project
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignzData;
